import {
  CLOSE_EDIT_DIALOG_COURSES,
  EDIT_FIELD_CHANGE_COURSES,
  LOADING_COURSES,
  LOADED_DETAILS_COURSES,
  UPDATE_REQUEST_COURSES,
  UPDATED_COURSES,
  RESET_COURSES,
} from './actions';

const initialState = {
  pending: false,
  isDirty: false,
  open: false,
  error: null,
  isValid: true,
  data: null,
  fieldsData: {},
};

const editCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_EDIT_DIALOG_COURSES:
      return {
        ...state,
        open: false,
      };

    case EDIT_FIELD_CHANGE_COURSES:
      return {
        ...state,
        fieldsData: {
          ...state.fieldsData,
          [action.id]: {
            value: action.value,
            isValid: action.isValid,
            type: action.prop,
          },
        },
      };

    case LOADING_COURSES:
      return {
        ...state,
        pending: true,
      };

    case LOADED_DETAILS_COURSES:
      return {
        ...state,
        pending: false,
        fieldsData: action.prop,
      };

    case UPDATE_REQUEST_COURSES:
      return {
        ...state,
        pending: true,
      };

    case UPDATED_COURSES:
      return {
        ...initialState,
        key: action.key,
      };

    case RESET_COURSES:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default editCourseReducer;
